import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isRiskManager from "../middlewares/isRiskManager";
import isCustomer from "../middlewares/isCustomer";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated,hasIntegraPermission]}, () => {

    Route.group({prefix: "customer", beforeEnter: [isCustomer]}, () => {

      Route.redirect("/", to => {
        return {name: "customer.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/order/OrderList.vue")
      ).name("customer.dashboard");

      Route.view("/order/create", () =>
        import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/order/OrderCreate.vue")
      ).name("customer.order_create");

      Route.view("/order/:id", () =>
        import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/order/OrderUpdate.vue")
      ).name("customer.order_update");

      Route.view("/profile", () =>
        import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/profile/Profile.vue")
      ).name("customer.profile");
      /*---------------------------------------------------------------------------------------------------------------
    |                                               USERS                                                          |
    ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "user"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/user/UserList")
        ).name("customer.user");
        Route.view("/create", () =>
          import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/user/UserCreate")
        ).name("customer.user_create");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "customer" */ "@/resources/views/logistic_manager/customer/user/UserUpdate")
        ).name("customer.user_update");
      });

    });
  });
});

export default Route.all();
